import script from "./CustomerBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBookings.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBookings.vue?vue&type=style&index=0&id=7d17e8f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d17e8f7"]])

export default __exports__